{
  "appointment-card": {
    "buttons": {
      "details": "Chi tiết"
    },
    "text": {
      "and-more": "và {{nr}} nữa",
      "cancelled": "ĐÃ HỦY",
      "minutes": "phút"
    }
  }
}
